import { IconDefinition } from "./types";

const tick: IconDefinition = {
  iconName: "tick",
  width: 512,
  height: 512,
  svgPathData:
    "M489.9 82.5l-14 19.5-264 368-16.5 23-20-20-136-136-17-17 33.9-33.9 17 17 116 116 247.5-345 14-19.5 39 28z",
  iconType: "fill",
  fontAwesomeName: "check",
  unicode: 0xf00c,
};

export { tick };
